/* eslint-disable camelcase */
import {
    getConsignmentAddDetails,
    initialconsignmentAddData,
    resetConsignmentAddDropDownDetails,
    resetConsignmentAddReference,
    setCartData,
    setOrderFromReportUsage,
    setSurgeryDetails,
    storeconsignmentAddReference,
} from '../actions';

import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    accountNumberZeroTrimmer,
    convertObjectToQueryParams,
    generate_UUID,
} from 'src/utils/util';
import { UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE } from '../actions/actionTypes';
import { GETCONSIGNMENTADDDETAILSDATA } from 'src/constants/productConstants';

export default function* consignmentAddOrderFromUsageDetails(action) {
    //const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/details/`;

    const { myCaseRef, resourceType } = action.payload;
    const objParams = {
        myCaseRef: myCaseRef,
        resourceType: resourceType,
    };
    let url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/details?${convertObjectToQueryParams(objParams)}`;
    // const isSubmitted = action.payload.isSubmittedFromSurgeryFlow;
    // delete action.payload.isSubmittedFromSurgeryFlow;
    //const payload = removeEmptyFieldsFromObject(action.payload);

    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put(initialconsignmentAddData());

        const { usageDetails } = result;

        if (usageDetails) {
            const {
                accountId,
                accountName,
                districtId,
                territoryId,
                // overridenReason,
                products,
            } = usageDetails;

            const trimmedAccountName = accountDetails.accountName.trim();
            const cleanAccountName = trimmedAccountName.endsWith('.') || 
                                    trimmedAccountName.endsWith('!') || 
                                    trimmedAccountName.endsWith('?')
                        ? trimmedAccountName.slice(0, -1)
                        : trimmedAccountName;
                    
            const accountIdData = {
                    accountId: accountId,
                    accountName: cleanAccountName.slice(0, -1),
                    accountFormattedName:
                        cleanAccountName +
                        accountNumberZeroTrimmer(accountId),
            };
            const accountDetails = {
                accountId: accountIdData,
                districtId: districtId, // ? districtId : 'Unknown',
                territoryId: territoryId, //? territoryId : 'Unknown',
            };

            let cartProducts =
                products &&
                products
                    .filter((product) => product.isAccountOwned)
                    .map((product) => {
                        delete product.batch;
                        delete product.counter;
                        delete product.entryNum;
                        delete product.hospitalQty;
                        delete product.isAdditionalCartEntry;
                        delete product.isBundleHeader;
                        delete product.isDeleteButtonPresent;
                        delete product.isLot;
                        delete product.isReplenish;
                        delete product.isSerialRequired;
                        delete product.isUnidRodItem;
                        delete product.itemBatchAndQty;
                        delete product.lotSerialNumber;
                        delete product.materialDesc;
                        delete product.modifiedByRep;
                        delete product.notModifiedEntry;
                        delete product.overrideUnitPrice;
                        delete product.payment;
                        delete product.reason;
                        delete product.repAdjustedQty;
                        delete product.replenishmentDetails;
                        delete product.rodEtching;
                        delete product.unidLineNumber;
                        return product;
                    });
            cartProducts =
                cartProducts &&
                cartProducts.map((product) => {
                    return product.usedQuantity && product.otherQuantity
                        ? ({
                              ...product,
                              productCFN: product.productCFN,
                              quantity: +product.usedQuantity,
                              // batchCurrentLocation: product?.batchAllocation?.currentLocation,
                              // batchId: product?.batchAllocation?.id,
                              // batchParked: product?.batchAllocation?.isParked,
                              productKey: generate_UUID(),
                              // discount: product?.overrideUnitPrice
                              //     ? calculateDiscountPercentage(
                              //         parseFloat(product?.unitPrice),
                              //         product?.overrideUnitPrice &&
                              //             parseFloat(product?.overrideUnitPrice)
                              //             ? parseFloat(product?.overrideUnitPrice)
                              //             : 0
                              //     )
                              //     : product?.overrideUnitPrice,
                              // adjustedPrice: product?.overrideUnitPrice,
                              // adjustedUnitPrice: product?.overrideUnitPrice,
                              // adjustedExtPrice: product?.overrideUnitPrice
                              //     ? getTotalExtendedPrice(
                              //         product?.overrideUnitPrice,
                              //         product?.quantity,
                              //         CONSIGNMENT_ADD_ORDERTYPE
                              //     )
                              //     : product?.overrideUnitPrice,
                          },
                          {
                              ...product,
                              productCFN: product.productCFN,
                              quantity: +product.otherQuantity,
                              // batchCurrentLocation: product?.batchAllocation?.currentLocation,
                              // batchId: product?.batchAllocation?.id,
                              // batchParked: product?.batchAllocation?.isParked,
                              productKey: generate_UUID(),
                              // discount: product?.overrideUnitPrice
                              //     ? calculateDiscountPercentage(
                              //         parseFloat(product?.unitPrice),
                              //         product?.overrideUnitPrice &&
                              //             parseFloat(product?.overrideUnitPrice)
                              //             ? parseFloat(product?.overrideUnitPrice)
                              //             : 0
                              //     )
                              //     : product?.overrideUnitPrice,
                              // adjustedPrice: product?.overrideUnitPrice,
                              // adjustedUnitPrice: product?.overrideUnitPrice,
                              // adjustedExtPrice: product?.overrideUnitPrice
                              //     ? getTotalExtendedPrice(
                              //         product?.overrideUnitPrice,
                              //         product?.quantity,
                              //         CONSIGNMENT_ADD_ORDERTYPE
                              //     )
                              //     : product?.overrideUnitPrice,
                          })
                        : {
                              ...product,
                              productCFN: product.productCFN,
                              quantity: product.usedQuantity
                                  ? product.usedQuantity
                                  : product.otherQuantity,
                              // batchCurrentLocation: product?.batchAllocation?.currentLocation,
                              // batchId: product?.batchAllocation?.id,
                              // batchParked: product?.batchAllocation?.isParked,
                              productKey: generate_UUID(),
                              // discount: product?.overrideUnitPrice
                              //     ? calculateDiscountPercentage(
                              //         parseFloat(product?.unitPrice),
                              //         product?.overrideUnitPrice &&
                              //             parseFloat(product?.overrideUnitPrice)
                              //             ? parseFloat(product?.overrideUnitPrice)
                              //             : 0
                              //     )
                              //     : product?.overrideUnitPrice,
                              // adjustedPrice: product?.overrideUnitPrice,
                              // adjustedUnitPrice: product?.overrideUnitPrice,
                              // adjustedExtPrice: product?.overrideUnitPrice
                              //     ? getTotalExtendedPrice(
                              //         product?.overrideUnitPrice,
                              //         product?.quantity,
                              //         CONSIGNMENT_ADD_ORDERTYPE
                              //     )
                              //     : product?.overrideUnitPrice,
                          };
                });

            yield put(setSurgeryDetails(accountDetails));
            yield put(
                setCartData({
                    products: cartProducts,
                    // overriddenReason: overridenReason,
                    getPricesForItems: cartProducts,
                    isFromUsage: true,
                    reportUsageMyCaseRef: myCaseRef,
                })
            );
            yield put(resetConsignmentAddDropDownDetails());
            yield put(setOrderFromReportUsage(true));
            yield put(resetConsignmentAddReference());
            yield put(getConsignmentAddDetails(GETCONSIGNMENTADDDETAILSDATA));
            yield put(storeconsignmentAddReference(myCaseRef));
        }

        // const modify_result = {
        //     ...result,
        //     isSubmitted,
        // };
        // yield put({
        //     type: UPDATE_CONSIGNMENT_ADD_DETAILS_SUCCESS,
        //     data: result,
        // });
        // yield put({ type: SET_CONSIGNMENT_ADD_CU_IN_PROGRESS, data: false });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE,
            data: {
                message: errorHandler('422'),
                statusCode: '422',
            },
        });
    }
}
